import React, { useEffect, useState } from 'react';
import { api, AED_short } from '../lib/api';
import { Link } from 'react-router-dom';
import { ShoppingBag, Users, TrendingUp } from 'lucide-react';

export default function Sales() {
  const [props, setProps] = useState([]);
  const [buyers, setBuyers] = useState([]);

  useEffect(() => {
    Promise.all([api.get('/properties'), api.get('/buyers')])
      .then(([p, b]) => { setProps(p.data); setBuyers(b.data); });
  }, []);

  const forSale = props.filter(p => p.stage === 'listed' || p.stage === 'sold');

  return (
    <div className="py-6 max-w-6xl mx-auto space-y-6" data-testid="sales-page">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-slate-500 mb-0.5">Portfolio</div>
        <h1 className="font-serif text-4xl">Sales & Buyers</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="glass p-5"><div className="overline">Listed</div><div className="font-serif text-3xl mt-2">{props.filter(p=>p.stage==='listed').length}</div></div>
        <div className="glass p-5"><div className="overline">Sold</div><div className="font-serif text-3xl mt-2 text-emerald-700">{props.filter(p=>p.stage==='sold').length}</div></div>
        <div className="glass p-5"><div className="overline">Active buyers</div><div className="font-serif text-3xl mt-2">{buyers.filter(b=>b.status!=='lost'&&b.status!=='closed').length}</div></div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {forSale.map(p => {
          const propBuyers = buyers.filter(b => b.property_id === p.id);
          return (
            <Link to={`/app/properties/${p.id}`} key={p.id} className="glass p-5 lift block">
              <div className="flex items-center gap-3 mb-3">
                {p.thumbnail_url && <img src={p.thumbnail_url} alt="" className="w-16 h-16 rounded-xl object-cover"/>}
                <div>
                  <div className="font-medium">{p.title}</div>
                  <div className="text-xs text-slate-500">{p.community}</div>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-2 text-xs mb-3">
                <div><div className="text-slate-500">Listed</div><div className="font-medium">{AED_short(p.listed_price_aed)}</div></div>
                <div><div className="text-slate-500">Sold</div><div className="font-medium">{AED_short(p.sold_price_aed)}</div></div>
                <div><div className="text-slate-500">ARV</div><div className="font-medium">{AED_short(p.arv_aed)}</div></div>
              </div>
              <div className="text-xs text-slate-600 border-t border-slate-100/60 pt-2">
                <Users size={12} className="inline mr-1"/> {propBuyers.length} buyer{propBuyers.length !== 1 ? 's' : ''}
              </div>
            </Link>
          );
        })}
        {forSale.length === 0 && <div className="col-span-2 text-center py-16 text-slate-400 glass">
          <ShoppingBag size={40} className="mx-auto mb-3 opacity-50"/> No properties listed or sold yet.
        </div>}
      </div>
    </div>
  );
}
